import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/team/teampageHero";
import Team from "../components/team/team";
import Partners from "../components/universal/partners";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Meet the Team | Regent Dental</title>
        <meta
          name="description"
          content="Meet the friendly and experienced Regent Dental team in West Yorkshire. Our skilled dentists and support staff are dedicated to delivering outstanding care."
        />
        <link rel="canonical" href="https://www.regent-dental.co.uk/team" />
      </Helmet>
      <Navbar />
      <Header />
      <Team />
      <Partners />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
